class HttpError {
    request: RequestInit;
    response: Response;
    responseBody: Blob | string | null;
    responseStatus: string;

    constructor(request: RequestInit, response: Response, responseBody:  Blob | string | null) {
        this.request = request;
        this.response = response;
        this.responseBody = responseBody;
        this.responseStatus = this.response.status.toString();

        console.error("HttpError", response);
    }
}

export default HttpError;
